export const userHeader = [
  { title: 'Full Name', key: 'fullName' },
  { title: 'First Name', key: 'firstName' },
  { title: 'Last Name', key: 'lastName' },
  // { title: 'Middle Name', key: 'middleName' },
  { title: 'Program Type', key: 'applicationStart_Display' },
  { title: 'Faculty', key: 'fieldOfInterest_Display' },
  { title: 'Phone', key: 'mobile', flag: 'mobile' },
  { title: 'Email', key: 'email' },
  { title: 'User Assign', key: 'userAssigned' },
  { title: 'Status', key: 'statusText', flag: 'status' },
  { title: 'Type', key: 'type' },
  { title: 'Country', key: 'nationality_Display' },
  { title: 'Hear About Us', key: 'howDoYouHear_Display' },
  { title: 'Contact Type', key: 'contactType_Display' },
  { title: 'Notes Count', key: 'noteCount' },
  { title: 'Email Count', key: 'emailCount' },
  { title: 'Source Of Connection', key: 'sourceOfConnection' },
  { title: 'Grade', key: 'grade_Display' },
  { title: 'High School GPA', key: 'highSchoolGPA' },
  { title: 'Curriculum', key: 'curriculum_Display' },
  {
    title: 'Last Email Received On',
    key: 'lastEmailReceivedOnDisplay',
  },
  { title: 'Priority', key: 'priority_Display' },
  { title: 'Country', key: 'country_Display' },
  { title: 'Job Title', key: 'jobTitle' },
  { title: 'School', key: 'schoolName' },
  { title: 'Created On', key: 'createdOnDisplay' },
];
